import { useEffect, useState } from 'react'

import Api from 'services/api'
import { PaywallPlan } from 'types/PaywallPlan'

const usePaywallPlans = (dealerId) => {
  const [plans, setPlans] = useState<Array<PaywallPlan>>(Array<PaywallPlan>)
  const [planOptions, setPlanOptions] = useState<Array<string>>([])
  const [arePaywallPlansLoaded, setArePaywallPlansLoaded] = useState(false)
  const [yearlyPlanNo, setYearlyPlanNo] = useState(0)
  const [monthlyPlanNo, setMonthlyPlanNo] = useState(0)

  useEffect(() => {
    Api.Paywall.getPlans()
      .then(res => {
        setPlans(res)
        setPlanOptions(res.map(plan => plan.name))
        setYearlyPlanNo(res.find(plan => plan.planId === 'diag_yearly')?.no || 0)
        setMonthlyPlanNo(res.find(plan => plan.planId === 'diag_monthly')?.no || 0)
      }).catch(() => {
        setArePaywallPlansLoaded(true)
      })
      .finally(() => setArePaywallPlansLoaded(true))
  }, [dealerId])

  return { plans, planOptions, yearlyPlanNo, monthlyPlanNo, arePaywallPlansLoaded }
}

export default usePaywallPlans
